import OorjitSettingsTab from './oorjit-settings';

export default OorjitSettingsTab;
